import { DeleteOutlined, SearchOutlined } from '@ant-design/icons';
import {
  Button,
  Col,
  Form,
  message,
  Row,
} from 'antd';
import { getPadronesMap } from 'api/recaudacion/utils';
import { InputSearchPro } from 'components/InputSearch';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { onError } from 'utils/handlers';
import padronToString from 'utils/padronesToString';
import { hasAdvanceSearchPermissions, hasPadronPermission } from 'utils/permission/models';
import BusquedaAvanzadaPadrones from 'views/Recaudacion/Caja/BusquedaAvanzadaPadrones';

const SearchForm = ({
  handleSearchData,
  // origenesDeCredito,
  setData,
  setParams,
  loading,
  // estatusDeEjecucionesList,
  tipoDePadron,
  setTipoDePadron,
  formSearch,
  padronFound,
  setPadronFound,
}) => {
  const { padrones: _padrones } = useSelector((s) => s.catalogs);
  const padrones = _padrones.filter((p) => hasPadronPermission(p.id) && p.id !== 5
    && p?.usado_en_ejecuciones);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [dataExternoBusqueda, setDataExternoBusqueda] = useState([]);
  const [visibleBusquedaPadronesBusqueda, setVisibleBusquedaPadronesBusqueda] = useState(false);
  // const [estatusDeEjecuciones, setEstatusDeEjecuciones] = useState([]);

  const formatPadronesBusqueda = async (_padron) => {
    const nombre_completo = padronToString(_padron, tipoDePadron);
    setPadronFound({ ..._padron, nombre_completo });
    formSearch.setFieldsValue({ object_id_padron: _padron.id });
  };

  const handleSearchBusqueda = async () => {
    try {
      setLoadingSearch(true);
      const { q } = formSearch.getFieldsValue();

      if (!q) {
        message.warn('Ingrese al menos un caracter para buscar.');
        setPadronFound(null);
        return;
      }

      const found = await getPadronesMap[tipoDePadron]({ q });
      const results = found?.results || found;

      if (results?.length === 1) {
        const [first] = results;
        await formatPadronesBusqueda(first);
        formSearch.setFieldValue({
          object_id_padron: first.id,
        });
      } else if (results?.length > 1) {
        setDataExternoBusqueda(found);
        setVisibleBusquedaPadronesBusqueda(true);
        setPadronFound(null);
      } else {
        message.warn('No se encontró ningún padron relacionado.');
        setPadronFound(null);
      }
    } catch (error) {
      onError(error);
    } finally {
      setLoadingSearch(false);
    }
  };

  const resetAndValidateBusqueda = () => {
    setPadronFound([]);
    setDataExternoBusqueda([]);
    setVisibleBusquedaPadronesBusqueda(false);
    formSearch.resetFields();
  };

  const displayTitle = (id) => {
    // Validación de entrada
    if (!id || typeof id !== 'number') {
      return 'Padrón';
    }

    // Búsqueda optimizada con early return
    const padron = padrones.find((p) => p?.id === id);

    // Validación del resultado
    if (padron?.descripcion) {
      return `Búsqueda de ${padron.descripcion}`;
    }

    // Fallback con información adicional
    if (padron) {
      return padron.nombre || padron.titulo || 'Padrón sin descripción';
    }

    return 'Padrón no encontrado';
  };

  // const onChangeOrigenDeCreditoBusqueda = async (value) => {
  //   try {
  //     setLoadingSearch(true);
  //     const _estatusDeEjecuciones = await getEstatusDeEjecuciones({ origen_del_credito: value });
  //     setEstatusDeEjecuciones(_estatusDeEjecuciones);
  //   } catch (error) {
  //     onError(error);
  //   } finally {
  //     setLoadingSearch(false);
  //   }
  // };

  return (
    <Form
      layout="vertical"
      form={formSearch}
      scrollToFirstError
      onFinish={handleSearchData}
      className="without-feedback"
    >
      {/* <Row gutter={10}>
        <Col xs={24} md={8}>
          <Form.Item name="folio" label="Folio de ejecución">
            <Input allowClear disabled={loadingSearch} />
          </Form.Item>
        </Col>
        <Col xs={24} md={8}>
          <Form.Item name="id" label="Folio ID de ejecución">
            <Input allowClear disabled={loadingSearch} />
          </Form.Item>
        </Col>
        <Col xs={24} md={8}>
          <Form.Item name="id_generacion" label="Folio ID de generación">
            <Input allowClear disabled={loadingSearch} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={10}>
        <Col xs={24} md={8}>
          <Form.Item name="origen_de_credito" label="Origen de crédito">
            <Select
              dataSource={origenesDeCredito}
              onChange={onChangeOrigenDeCreditoBusqueda}
              disabled={loadingSearch}
            />
          </Form.Item>
        </Col>
        <Col xs={24} md={8}>
          <Form.Item name="estatus" label="Estatus actual de ejecución">
            <Select dataSource={estatusDeEjecuciones} disabled={loadingSearch} />
          </Form.Item>
        </Col>
        <Col xs={24} md={8}>
          <Form.Item name="siguiente_estatus" label="Siguiente estatus de ejecución">
            <Select dataSource={estatusDeEjecucionesList} disabled={loadingSearch} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={10}>
        <Col xs={24} md={8}>
          <Form.Item name="solo_cartera_ejecutada" label="Solo con estado de cartera ejecutada">
            <Select dataSource={[]} disabled={loadingSearch} />
          </Form.Item>
        </Col>
        <Col xs={24} md={8}>
          <Form.Item name="solo_gastos_ejecucion" label="Solo con estado de gastos de ejecución">
            <Select dataSource={[]} disabled={loadingSearch} />
          </Form.Item>
        </Col>
        <Col xs={24} md={8}>
          <Form.Item name="fecha_ejecucion" label="Fecha de ejecución">
            <DatePicker.RangePicker
              disabled={loadingSearch}
              format="DD/MM/YYYY"
              placeholder={['', '']}
            />
          </Form.Item>
        </Col>
      </Row> */}
      <Row gutter={10}>
        <InputSearchPro
          disabled={loadingSearch}
          prefix={{
            style: { width: '100%' },
            name: 'tipo_de_padron',
            label: 'padron',
            dataSource: padrones,
            onChange: setTipoDePadron,
            valueProp: 'content_type',
          }}
          name="q"
          onClickAdvanced={hasAdvanceSearchPermissions(tipoDePadron)
            ? () => setVisibleBusquedaPadronesBusqueda(true) : null}
          label={displayTitle(tipoDePadron)}
          inputProps={{
            onPressEnter: handleSearchBusqueda,
          }}
          breakPoints={{
            xs: 24,
            sm: 24,
            md: 16,
          }}
          resultProps={{
            breakPoints: {
              xs: 24,
              sm: 24,
              md: 16,
            },
            name: 'object_id_padron',
            labelProp: 'nombre_completo',
            label: displayTitle(tipoDePadron),
            dataSource: padronFound,
            onClear: resetAndValidateBusqueda,
          }}
        />
      </Row>
      <Form.Item hidden>
        <Button type="primary" htmlType="submit" />
      </Form.Item>
      <Row gutter={[10, 10]}>
        <Col xs={24} md={8}>
          <Button
            htmlType="button"
            onClick={() => {
              resetAndValidateBusqueda();
              setData({ count: 0, results: [] });
              setParams({});
            }}
            icon={<DeleteOutlined />}
            block
          >
            Limpiar
          </Button>
        </Col>
        <Col xs={24} md={8}>
          <Button htmlType="submit" loading={loading} icon={<SearchOutlined />} block>
            Buscar
          </Button>
        </Col>
      </Row>
      <br />
      <BusquedaAvanzadaPadrones
        visible={visibleBusquedaPadronesBusqueda}
        setVisible={setVisibleBusquedaPadronesBusqueda}
        callback={formatPadronesBusqueda}
        dataExterno={dataExternoBusqueda}
        setDataExterno={setDataExternoBusqueda}
        tipoDePadron={tipoDePadron}
      />
    </Form>
  );
};

SearchForm.propTypes = {
  handleSearchData: PropTypes.func.isRequired,
  // origenesDeCredito: PropTypes.arrayOf(PropTypes.shape({
  //   id: PropTypes.number,
  //   descripcion: PropTypes.string,
  // })).isRequired,
  setData: PropTypes.func.isRequired,
  setParams: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  // estatusDeEjecucionesList: PropTypes.arrayOf(PropTypes.shape({
  //   id: PropTypes.number,
  //   descripcion: PropTypes.string,
  // })).isRequired,
  tipoDePadron: PropTypes.number.isRequired,
  setTipoDePadron: PropTypes.func.isRequired,
  formSearch: PropTypes.shape({
    getFieldsValue: PropTypes.func.isRequired,
    setFieldsValue: PropTypes.func.isRequired,
    setFieldValue: PropTypes.func.isRequired,
    resetFields: PropTypes.func.isRequired,
  }).isRequired,
  padronFound: PropTypes.shape({
    id: PropTypes.number,
    nombre_completo: PropTypes.string,
  }).isRequired,
  setPadronFound: PropTypes.func.isRequired,
};

export default SearchForm;
